import React, { forwardRef } from 'react';
// import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Textarea = forwardRef((props, ref) => {
    return (
        <textarea
            className='w-full bg-sand border-grey type-style-8 rounded-button placeholder:text-placeholder'
            ref={ref}
            {...props} />
    );
});

Textarea.displayName = 'Textarea';

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

Textarea.propTypes = {};

export default Textarea;
